import React from "react";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Column 1 — Brand */}
        <div className="footer-section">
          <h3>Ranthambore Tour Packages & Travel Assistance</h3>

          <p>
            Explore Ranthambore tour packages with safari experiences, hotel stays, and complete travel assistance.
          </p>

          <p className="location">
            📍 Gurgaon, Haryana, India
          </p>

          <p className="business-name">
            <strong>Business Name (Registered):</strong> Ranthambore Safari Booking Assistance(MSME Registered) <br />
            <strong>Operating As:</strong> Ranthambore Tours & Travel Assistance
          </p>
        </div>

        {/* Column 2 — Quick Links */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/jeep-safari-ranthambore">Jeep Safari Guide</a></li>
            <li><a href="/canter-safari-ranthambore">Canter Safari Guide</a></li>
            <li><a href="/">Tour Packages</a></li>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
            <li><a href="/terms-conditions">Terms & Conditions</a></li>
            <li><a href="/booking-process">How It Works</a></li>
          </ul>
        </div>

        {/* Column 3 — Contact */}
        <div className="footer-section">
          <h4>Contact Us</h4>

          <p className="phone">
            📞 <a href="tel:+919217691062">+91-9217691062</a>
          </p>

          <p>
            ✉{" "}
            <a href="mailto:support@safariranthamborebooking.com">
              support@safariranthamborebooking.com
            </a>
          </p>

          <p className="business-info">
            Registered MSME Enterprise | Based in Gurgaon, Haryana
          </p>

          <a
            href="https://wa.me/919217691062"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            Plan Trip on WhatsApp
          </a>
        </div>

      </div>

      {/* Bottom Strip */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Ranthambore Tours & Travel Assistance. All Rights Reserved.
      </div>

      {/* Disclaimer */}
      <div className="footer-disclaimer">
        <p>
          Ranthambore Tours & Travel Assistance is an independent travel service helping travelers plan Ranthambore trips including safari experiences, stays, and travel assistance.
        </p>

        <p>
          We are not affiliated with the Forest Department or any government authority. Registered MSME (Govt. of India): UDYAM-HR-05-0182921.
        </p>

        <p>
          All safari experiences are conducted through authorized operators as per park regulations.
        </p>
      </div>

    </footer>
  );
};

export default Footer;